export enum InternalFieldNames {
  AddressValidation = `@isAV`,
  DataSource = `dataSource`,
  DuplicateCheck = `@isDC`,
  Exported = `@isExported`,
  Name = `name`,
  UserName = `@users`,
  OriginId = `@originId`,
  RelevantCount = `@relevantCount`,
  TargetUrl = `@targetUrl`
}
